import { t } from 'i18next';
import FormDrawer from '../form-drawer/form-drawer.component';
import SendOfferForm from 'components/forms/send-offer-form/send-offer-form.component';
import { useSendOfferForm } from 'components/forms/send-offer-form/send-offer-form.hooks';
import { useSendOfferMutation } from 'api/offers-domain/offers-domain';

const SendOfferDrawer = ({ open, close, drawerData }) => {
  const { form } = useSendOfferForm();

  const [sendOfferMutation, { isLoading: updateSendOfferLoading }] =
    useSendOfferMutation();

  const submit = async data => {
    try {
      await sendOfferMutation({
        userId: drawerData.customerId,
        offerId: data?.loyaltyOffer,
        ignoreBlackoutPeriod: data?.ignoreBlackoutPeriod,
        ignoreDistributionRules: data?.ignoreDistributionRules,
        ignoreRedistributionMode: data?.ignoreRedistributionMode,
      });
      close();
      form.reset();
    } catch (_e) {}
  };

  const cancel = () => {
    close();
    form.reset();
  };

  return (
    <FormDrawer
      title={t('page.customers.card.sendOffer')}
      submitButtonLabel={t('page.customers.card.sendOffer')}
      data-testid="SendOfferDrawer.Drawer"
      open={open}
      onClose={cancel}
      onValid={submit}
      cancel={cancel}
      formMethods={form}
      isLoading={updateSendOfferLoading}
    >
      <SendOfferForm />
    </FormDrawer>
  );
};

export default SendOfferDrawer;
